import React, { useState } from 'react';
import {
    Box,
    Typography,
    Alert
} from '@mui/material';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

const PresentationForm: React.FC = () => {
    useDocumentTitle('Edit Presentation');

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" gutterBottom>
                Edit Presentation
            </Typography>

            <Alert severity="info">
                Presentation form component - implementation in progress
            </Alert>
        </Box>
    );
};

export default PresentationForm;
